import { contractInitialState } from '@/modules/contract/entities/contants/contract';
import { costCenterInitialState } from '@/modules/negotiation/entities/constantes/costCenter';
import { Negotiation } from '@/modules/negotiation/entities/interfaces/negotiation';
import { productInitialState } from '@/modules/plan/entities/contants/plan';

export const negotiationInitalState: Negotiation = {
  contractId: '',
  productId: '',
  brokerId: '',
  costCenterId: '',
  reimbursement: 0,
  product: productInitialState,
  contract: contractInitialState,
  costCenter: costCenterInitialState,
  markups: [],
};
